/**
 * Miniatura de un archivo subido, para LISTAS, TARJETAS, GRILLAS y TILES.
 *
 * Cada imagen que se sube genera una miniatura webp de 400 px (`thumbUrl` en el entry;
 * en un video es el fotograma). Una grilla de 120 px no necesita bajar la foto completa
 * (a veces varios MB): usa `urlMiniatura`. Los visores, lightbox, carruseles a tamaño
 * completo y las descargas SÍ usan `url`.
 *
 * Si la entrada no tiene miniatura (`thumbUrl` nulo o ausente: archivos viejos, formatos
 * que no se pudieron reducir) cae a la URL completa; si no hay ninguna, devuelve "".
 */

export interface ConMiniatura {
  url?: string | null;
  thumbUrl?: string | null;
}

export function urlMiniatura(entry: ConMiniatura | null | undefined): string {
  return entry?.thumbUrl || entry?.url || "";
}
